import AppConfig from '../util/config';

export default function api(url, options) {
  options = {
    ...options,
    headers: {
      ...(options ? options.headers : {}),
      'Content-Type': 'application/json'
    },
    mode: 'cors'
  };

  return fetch(`${AppConfig.UMBRELLA_API_URL}${url}`, options).then(response => {
    if (!response.ok) {
      return response.json().then(err => {
        throw new Error(err.error || err.message);
      });
    }
    return response.json();
  });
}
